import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { removeToolTip } from 'src/app/_helpers/Utils'
import { IHandlerOperation, Section, TypeOperationEnum } from 'src/app/models/HandlerOperation'

@Component({
	selector: 'select-handler-operation',
	templateUrl: './select-handler-operations.component.html'
})
export class SelectHandleOperation implements OnInit, OnDestroy {

	@Input() public allHandlerOperations: Array<IHandlerOperation> = []
	@Input() public handlerOperationsFromParent: Array<{
		idMongo: string,
		operation: string,
		legalFundamentation?: string,
		sections: Array<Section>
		typeOperation: TypeOperationEnum
	}> = []
	@Output() public closeSelector = new EventEmitter<Array<{
		idMongo: string,
		operation: string,
		legalFundamentation?: string,
		sections: Array<Section>
		typeOperation: TypeOperationEnum
	}>>()

	public handlerOperationsSelected: Array<IHandlerOperation> = []

	public companyId = localStorage.getItem('companyId')

	public async ngOnInit(): Promise<void> {
		document.body.style.overflow = 'hidden'

		this.handlerOperationsFromParent.forEach(management => {
			const handleOperationFind =
				this.allHandlerOperations.find(handlerOperation => handlerOperation._id === management.idMongo)

			if (handleOperationFind) {
				this.handlerOperationsSelected.push(handleOperationFind)
			}
		})
	}

	public selectHandlerOperation(managementSelected: IHandlerOperation) {
		const managmentAlreadySelected =
			this.handlerOperationsSelected.find(management => management._id == managementSelected._id)

		if (managmentAlreadySelected) return

		this.handlerOperationsSelected.push(managementSelected)
	}

	public unSelectHandlerOperation(indexSelected: number) {
		if (this.handlerOperationsSelected.length == 1 ) return

		this.handlerOperationsSelected.splice(indexSelected, 1)
	}

	public closeHandlerOperations() {

		const handlerOperationsToReturn: Array<{
			idMongo: string,
			operation: string,
			legalFundamentation?: string,
			sections: Array<Section>,
			typeOperation: TypeOperationEnum
		}> = []

		this.handlerOperationsSelected.map(management => {
			const handlerOperationAlreadySelect =
				this.handlerOperationsFromParent.find(handlerOperation => handlerOperation.idMongo == management._id)

			if (handlerOperationAlreadySelect) {
				handlerOperationsToReturn.push(handlerOperationAlreadySelect)
			} else {
				handlerOperationsToReturn.push({
					idMongo: management._id,
					operation: management.operation,
					legalFundamentation: management.legalFundamentation,
					sections: management.sections,
					typeOperation: management.typeOperation,
				})
			}
		})

		this.closeSelector.emit(handlerOperationsToReturn)
		removeToolTip()
	}

	public ngOnDestroy(): void {
		document.body.style.overflow = 'auto'
	}
}
